type HighlightKeysProps = {
  text?: string;
  highlight?: string;
};

export const HighlightKeys = ({ text, highlight }: HighlightKeysProps) => {
  if (!text) return null;
  if (!highlight) return text;

  const parts = text.split(new RegExp(`(${highlight})`, 'gi'));

  return (
    <span>
      {parts.map((part, index) =>
        part.toLowerCase() === highlight.toLowerCase() ? (
          <span
            key={index}
            className="vt-colors-accents-accent-1-400 vt-font-weight-semibold"
          >
            {part}
          </span>
        ) : (
          <span key={index}>{part}</span>
        )
      )}
    </span>
  );
};
